import {pub, sub} from './pubsub.js'

function next() {
    pub("tabNext")
}

function prev() {
    pub("tabPrev")
}

function destroy(tab) {
    pub("tabDestroy", tab)
}

function destroyAddCallback(cb) {
    sub("tabDestroy", cb)
}

function destroyCurrent() {
    pub("tabDestroyCurrent")
}

function destroyCurrentAddCallback(cb) {
    sub("tabDestroyCurrent", cb)
}

function dup() {
    pub("tabDup")
}

function dupAddCallback(cb) {
    sub("tabDup", cb)
}

function dupCur() {
    pub("dupCur")
}

function dupCurAddCallback(cb) {
    sub("dupCur", cb)
}

function fullscreenCur() {
    pub("fullscreenCur")
}
function fullscreenCurAddCallback(cb) {
    sub("fullscreenCur", cb)
}

function currentReconnect() {
    pub("tabCurrentReconnect")
}

function currentReconnectAddCallback(cb) {
    sub("tabCurrentReconnect", cb)
}

// curent tab change from ${from} to ${to}
// caller: who call this function
// to: new current tab key
// from: old tab key
function currentChange(caller, to, from) {
    // console.log(`tabCurrentChange: caller: ${caller}, to: ${to}, from: ${from}`)
    pub("tabCurrentChange", {
        to: to,
        from: from,
    })
}

function currentChangeAddCallback(cb) {
    sub("tabCurrentChange", cb)
}

function newTab(sessAndPath) {
    pub("tabNewTab", sessAndPath)
}
function newTabAddCallback(cb) {
    sub("tabNewTab", cb)
}

let curTabKey = ""

export default {
    next,
    prev,
    destroy,
    destroyAddCallback,
    destroyCurrent,
    destroyCurrentAddCallback,
    dup,
    dupAddCallback,
    dupCur,
    dupCurAddCallback,
    fullscreenCur,
    fullscreenCurAddCallback,
    currentReconnect,
    currentReconnectAddCallback,
    currentChange,
    currentChangeAddCallback,
    newTab,
    newTabAddCallback,
    curTabKey,
}
